import styles from './EmptyState.module.scss';

const AgreementsEmptyState = () => (
    <div
        className={styles.root}
        data-testid="agreements-empty-state"
    >
        <img
            className={styles.image}
            src="/images/bookings/EmptyUpcoming.svg"
            alt="No agreements"
        />
        <h2 className={styles.title}>Don&apos;t get too comfy.</h2>
        <p className={styles.subtitle}>This will fill up soon enough.</p>
    </div>
);

export default AgreementsEmptyState;
